module.exports = __webpack_public_path__ + "img/skull_1_bj.ad7df85f.png";